import { render, staticRenderFns } from "./iconSvgJpeg.vue?vue&type=template&id=0322e966&scoped=true&"
import script from "./iconSvgJpeg.vue?vue&type=script&lang=js&"
export * from "./iconSvgJpeg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0322e966",
  null
  
)

export default component.exports